<template>
  <div>
    <!-- 箭头 -->
    <div
      :class="this.windowWith > 992 ? 'arrows' : 'arrowsTop'"
      @click="changeMachineShow"
    >
      <!-- <svg :icon-class="Arrowimg" alt="" style="color: red" /> -->
      <svg-icon :icon-class="Arrowimg" class="MapArrorSvg"></svg-icon>
    </div>
    <!-- :style="{width: this.windowWith>992? '25%' : '94%'}" -->
    <!-- 数据显示 -->
    <transition
      :name="this.windowWith > 992 ? 'machineListFade' : 'machineListFade2'"
    >
      <div
        class="machineShow"
        :style="{
          width: this.windowWith > 992 ? '500px' : '95%',
          right: this.windowWith > 992 ? '44px' : '22px',
        }"
        v-if="this.machineShow"
      >
        <!-- 机器状态示例 -->
        <div class="status">
          <div>
            <img src="@/assets/mapImg/M1.png" alt="" v-if="urlFile=='ja'"/>
            <img src="@/assets/mapImgHK/M1.png" alt="" v-if="urlFile=='HK'"/>
            <img src="@/assets/mapImgMINI/M1.png" alt="" v-if="urlFile=='MINI'"/>
            <img src="@/assets/mapImgOlar/M1.png" alt="" v-if="urlFile=='Olar'"/>
            <img src="@/assets/mapImgJAMINI/M1.png" alt="" v-if="urlFile=='JAMINI'"/>
            <p>
              <small
                >{{ $t("map.machineState.MoreSpace") }}<br />
                <span style="color: #56c08f; font-size: 10px">0 - 70%</span>
              </small>
            </p>
          </div>

          <div>
            <img src="@/assets/mapImg/M2.png" alt=""  v-if="urlFile=='ja'"/>
           <img src="@/assets/mapImgHK/M2.png" alt="" v-if="urlFile=='HK'"/>
           <img src="@/assets/mapImgMINI/M2.png" alt="" v-if="urlFile=='MINI'"/>
           <img src="@/assets/mapImgOlar/M2.png" alt="" v-if="urlFile=='Olar'"/>
            <img src="@/assets/mapImgJAMINI/M2.png" alt="" v-if="urlFile=='JAMINI'"/>

            <p>
              <small
                >{{ $t("map.machineState.ProvideService") }}<br />
                <span style="color: #f5a075; font-size: 10px"
                  >70% - 90%</span
                ></small
              >
            </p>
          </div>
          <div>
            <img src="@/assets/mapImg/M3.png" alt=""  v-if="urlFile=='ja'"/>
            <img src="@/assets/mapImgHK/M3.png" alt="" v-if="urlFile=='HK'"/>
            <img src="@/assets/mapImgMINI/M3.png" alt="" v-if="urlFile=='MINI'"/>
            <img src="@/assets/mapImgOlar/M3.png" alt="" v-if="urlFile=='Olar'"/>
            <img src="@/assets/mapImgJAMINI/M3.png" alt="" v-if="urlFile=='JAMINI'"/>

            <p>
              <small
                >{{ $t("map.machineState.NearlyOverflow") }}<br />
                <span style="color: #fe5352; font-size: 10px">90% - 100%</span>
              </small>
            </p>
          </div>
          <div>
            <img src="@/assets/mapImg/M4.png" alt=""  v-if="urlFile=='ja'"/>
            <img src="@/assets/mapImgHK/M4.png" alt="" v-if="urlFile=='HK'"/>
            <img src="@/assets/mapImgMINI/M4.png" alt="" v-if="urlFile=='MINI'"/>
            <img src="@/assets/mapImgOlar/M4.png" alt="" v-if="urlFile=='Olar'"/>
            <img src="@/assets/mapImgJAMINI/M4.png" alt="" v-if="urlFile=='JAMINI'"/>

            <p>
              <small
                >{{ $t("map.machineState.outOfService") }}<br />&nbsp</small
              >
            </p>
          </div>
          <!-- <li>
              <img src="@/assets/mapImg/M1.png" alt="" />
              <p>
                <small>Unavailable</small>
              </p>
            </li> -->
        </div>
        <!-- 搜索部分 -->
        <div class="search">
          <el-input
            class="inputSearch"
            :placeholder="$t('map.search.address')"
            v-model="blurry"
            clearable
          ></el-input>
          <el-cascader
            :props="propsDistrict"
            style="width: 140px; margin-right: 5px; margin-left: 14px"
            collapse-tags
            :show-all-levels="false"
            ref="Districts"
            @change="getDistricts"
          ></el-cascader>
          <!-- <el-cascader
            style="width: 140px; margin-right: 5px; margin-left: 14px"
            :props="propsDistrict"
            @change="getDistricts"
            :show-all-levels="false"
            ref="Districts"
          > -->
          </el-cascader>
          <el-select
            style="width: 120px; margin-right: 5px"
            v-model="DTypeList"
            :placeholder="$t('map.search.location')"
            class="inputoptions"
            @change="getDType"
          >
            <el-option
              v-for="item in this.loactionType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            style="width: 100px"
            v-model="RecycleTypevalue"
            :placeholder="$t('map.search.recycleType')"
            class="inputoptions"
            @change="changeRecycleType"
          >
            <el-option
              v-for="item in RecycleType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            class="searchBtn"
            icon="el-icon-search"
            @click="search"
          ></el-button>
          <el-button
            type="primary"
            class="resetBtn"
            icon="el-icon-refresh-left"
            @click="reset"
          ></el-button>
        </div>
        <!-- 地址 -->
        <div class="address">
          <el-tooltip
            effect="light"
            placement="left-end"
            :class="LocationTypePre.length!==1? 'pre':'pre last'"
            v-for="(item, index) in LocationTypePre"
            :key="index"
            :style="{
              margin: 0,
              height: '100%',
              flex: item.percentage,
              backgroundColor: item.color,
            }"
          >
            <div slot="content">
              {{ $t("DataAnalysis.num") + ":" + item.number }}<br />
              {{ $t("DataAnalysis.pre") + ":" + item.percentage + "%" }}
            </div>

            <p>{{ item.name }}</p>
          </el-tooltip>
          <!-- <div>
            <p>{{ item.name }}</p>
          </div> -->
        </div>
        <!-- 设备列表 -->
        <div class="list">
          <!-- <div
            style=""
            class="leftArrow"
            @click="minValPlus"
            v-if="arrowShow"
          ></div>
          <div
            style=""
            class="rightArrow"
            @click="maxValPlus"
            v-if="arrowShow"
          ></div> -->
          <el-tabs
            type="card"
            v-model="activeName"
            @tab-click="changeShowAddress"
          >
            <!-- 全部区域 -->

            <el-tab-pane :label="$t('map.mapTableTitle')" name="1">
              <!-- :minVal="minVal" -->
              <list
                :listInfo="Info"
                :RecycleTypevalue="RecycleTypevalue"
                :activeList="activeName"
              ></list>
            </el-tab-pane>
            <!-- v-if="item.isShowVal >= minVal && item.isShowVal <= maxVal"
              class="showVal" -->
            <el-tab-pane
              v-for="(item, index) in tableDistrict"
              :label="item.label"
              :name="item.value.toString()"
              :key="item.value"
            >
              <!-- :minVal="minVal"
                :index="index"
                :length1="tableDistrict.length" -->
              <list
                :listInfo="Info"
                :RecycleTypevalue="RecycleTypevalue"
                :activeList="activeName"
              ></list>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { number } from "echarts";
import list from "./list.vue";
export default {
  props: ["Info"],
  created() {
    this.getRecycleType();
    this.getLocationType();
    this.getTypepercentage();
  },
  components: {
    list,
  },
  mounted() {
    this.getProjectList();
    window.onresize = () => {
      this.windowWith = document.documentElement.clientWidth;
    };
    if (this.windowWith < 992) {
      this.Arrowimg = "topArrow";
    }
    this.addressSearch = this.options;
    this.arrowShowFn();
    if (process.env.VUE_APP_API_BASE_NAME == "hk") {
      this.urlFile = "HK";
    } else if (process.env.VUE_APP_API_BASE_NAME == "ja") {
      this.urlFile = "ja";
      if (localStorage.getItem("project") == "17") {
        this.urlFile = "JAMINI";
      }
    } else if (process.env.VUE_APP_API_BASE_NAME == "mini") {
      this.urlFile = "MINI";
    } else if (process.env.VUE_APP_API_BASE_NAME == "olar") {
      this.urlFile = "Olar";
    }
  },
  data() {
    return {
      arrowShow: false,
      minVal: 0,
      maxVal: 2,
      legend: [this.$t("DataAnalysis.num"), this.$t("DataAnalysis.pre")],
      Arrowimg: "leftArrow",
      windowWith: document.documentElement.clientWidth,
      machineShow: true,
      bgcColor: [
        "#e29135",
        "#94c6cd",
        "#4a5f57",
        "#b8dbb3",
        "#72b063",
        "#719AAc",
      ],
      options: [
        {
          value: "香港島",
          label: "香港島",
          children: [
            {
              value: "中西區",
              label: "中西區",
            },
            {
              value: "東區",
              label: "東區",
            },
            {
              value: "南區",
              label: "南區",
            },
            {
              value: "灣仔",
              label: "灣仔",
            },
          ],
        },
        {
          value: "九龍",
          label: "九龍",
          children: [
            {
              value: "九龍城",
              label: "九龍城",
            },
            {
              value: "觀塘",
              label: "觀塘",
            },
            {
              value: "深水埗",
              label: "深水埗",
            },
            {
              value: "黃大仙",
              label: "黃大仙",
            },
            {
              value: "油尖旺",
              label: "油尖旺",
            },
          ],
        },
        {
          value: "新界",
          label: "新界",
        },
      ],
      radio1: "全部區域",
      options2: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      // 位置類型
      loactionType: null,
      // 地區模块
      propsDistrict: {
        lazy: true,
        lazyLoad: this.getDistrict,
        multiple: true,
      },
      LocationTypePre: null,
      // 图片列表
      imgList: [
        require("@/assets/mapImg/M1.png"),
        require("@/assets/mapImg/M2.png"),
        require("@/assets/mapImg/M3.png"),
        require("@/assets/mapImg/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      // 回收類型
      RecycleType: [],
      RecycleTypevalue: 1,
      // 列表显示
      activeName: "1",
      // 地区列表
      districtList: "",
      //地区类型列表
      DTypeList: "",
      // 表格头部地区列表
      tableDistrict: "",
      // 地区搜索
      blurry: "",
      districtId: "",
      urlFile: "",
    };
  },
  methods: {
    minValPlus() {
      if (this.minVal >= 3) {
        this.minVal -= 3;
        this.maxVal -= 3;
        if (this.activeName >= 4) {
          // this.activeName = (Number(this.activeName) - 3).toString();
          this.changeShowAddress({
            name: (Number(this.activeName) - 3).toString(),
          });
        }
      }
    },
    maxValPlus() {
      if (
        this.tableDistrict.length >= 3 &&
        this.minVal <= this.tableDistrict.length - 3
      ) {
        this.minVal += 3;
        this.maxVal += 3;
        if (this.activeName !== "1") {
          // this.activeName = (Number(this.activeName) + 3).toString();
          this.changeShowAddress({
            name: (Number(this.activeName) + 3).toString(),
          });
        }
        if (
          this.activeName >
          this.tableDistrict[this.tableDistrict.length - 1].value
        ) {
          // this.activeName =
          //   this.tableDistrict[this.tableDistrict.length - 1].value.toString();
          this.changeShowAddress({
            name: this.tableDistrict[
              this.tableDistrict.length - 1
            ].value.toString(),
          });
        }
      }
    },
    // 修改箭头方向
    changeMachineShow() {
      if (this.windowWith > 992) {
        this.machineShow = !this.machineShow;
        if (this.machineShow == true) {
          this.Arrowimg = "rightArrow";
          setTimeout(() => {
            // this.arrowShowFn();
          }, 100);
        } else if (this.machineShow == false) {
          this.Arrowimg = "leftArrow";
        }
      } else if (this.windowWith <= 992) {
        this.machineShow = !this.machineShow;
        if (this.machineShow == true) {
          this.Arrowimg = "topArrow";
          // this.arrowShowFn();
        } else {
          this.Arrowimg = "bottomArrow";
        }
      }
    },
    arrowShowFn() {
      let tab = document.querySelector(".list");
      tab.addEventListener(
        "mouseenter",
        () => {
          this.arrowShow = true;
        },
        false
      );
      tab.addEventListener(
        "mouseleave",
        () => {
          this.arrowShow = false;
        },
        false
      );
    },
    // 获得位置類型
    getLocationType() {
      this.$http.locationType.getLocationType().then((res) => {
        if (res.code == 200) {
          this.loactionType = res.datas;
        }
      });
    },
    // 获得位置类型占比
    getTypepercentage() {
      this.$http.locationType.getpercentage().then((res) => {
        if (res.code == 200) {
          res.datas.sort((a, b) => {
            //return( a[age] - b[age])
            return b.percentage - a.percentage;
          });
          res.datas.forEach((item, index) => {
            item.color = this.bgcColor[index];
          });
          this.LocationTypePre = res.datas;
        }
      });
    },
    // 获得地区类型
    getDistrictList(params) {
      let res = this.$http.district.getDistrict(params);
      return res;
    },
    getProjectList() {
      let res = this.$http.project.getProject();
      return res;
    },
    // 地區類型
    async getDistrict(node, resolve) {
      console.log(node, "node");
      if (node.level == 0) {
        let params = {};
        let res1 = await this.getProjectList();
        let districtId;
        res1.datas.forEach((item) => {
          if (localStorage.getItem("project") == item.id) {
            districtId = item.districtId;
          }
        });
        params.pid = districtId || 6;
        let res = await this.getDistrictList(params);
        const nodes = await res.datas.map((item, index) => ({
          value: item.id,
          label: item.name,
          leaf: !item.hasChildren,
          // isShowVal: index,
        }));
        this.tableDistrict = nodes;
        // nodes.push(
        //   { value: 10, label: "香港1", isShowVal: 3 },
        //   { value: 11, label: "香港2", isShowVal: 4 },
        //   { value: 12, label: "香港3", isShowVal: 5 },
        //   { value: 13, label: "香港4", isShowVal: 6 },
        //   { value: 14, label: "香港5", isShowVal: 7 }
        // );
        resolve(nodes);
      }
      if (node.level != 0) {
        let params = {};
        params.pid = node.data.value;
        if (node.hasChildren) {
          let res = await this.getDistrictList(params);
          const nodes = res.datas.map((item) => ({
            value: item.id,
            label: item.name,
            leaf: !item.hasChildren,
          }));
          resolve(nodes);
        } else {
          resolve(null);
        }
      }
    },
    // 获得回收類型
    async getRecycleType() {
      let res = await this.$http.recycletype.getRecycletype();
      if (res.code == 200) {
        this.RecycleType = res.datas;
      }
    },
    // 更改回收類型
    changeRecycleType(val) {
      this.$emit("changeRecycleType", val);
    },
    // 修改显示区域
    changeShowAddress(val) {
      this.activeName = val.name;
      let params = {};
      if (val.name == 1) {
        this.$emit("getMachineInfo", params);
      } else {
        params.region = val.name;
        this.$emit("getMachineInfo", params);
      }
    },
    // 获取地区选中数据
    getDistricts(val) {
      this.districtList = [];
      let arr = this.$refs["Districts"].getCheckedNodes();
      arr.forEach((item) => {
        this.districtList.push(item.value);
      });
    },
    // 获取地区选中数据
    getDType(val) {
      this.DTypeList = val;
    },

    // 搜索
    search() {
      let params = {};
      if (this.districtList) {
        params.districts = this.districtList.toString();
      }
      if (this.DTypeList) {
        params.PType = this.DTypeList;
      }
      if (this.blurry) {
        params.blurry = this.blurry;
      }
      this.activeName = "1";
      this.$emit("getMachineInfo", params);
    },
    // 重置
    reset() {
      this.districtList = null;
      this.blurry = null;
      this.$refs["Districts"].$refs.panel.clearCheckedNodes();
      this.DTypeList = null;
      this.RecycleTypevalue = 1;
    },
  },
  watch: {
    windowWith: function () {
      if (this.windowWith > 992) {
        if (this.machineShow) {
          this.Arrowimg = "rightArrow";
        } else {
          this.Arrowimg = "leftArrow";
        }
      } else if (this.windowWith <= 992) {
        if (this.machineShow) {
          this.Arrowimg = "topArrow";
        } else {
          this.Arrowimg = "bottomArrow";
        }
      }
    },
    Info: {
      handler(newValue, oldValue) {
        this.Info = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/deep/#tab-1 {
  width: 125px;
}
.leftArrow {
  position: absolute;
  z-index: 1000;
  margin-top: 7px;
  left: 125px;
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: transparent transparent transparent rgb(83, 168, 133);
}
.rightArrow {
  position: absolute;
  z-index: 1000;
  margin-top: 7px;
  right: 0px;
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: transparent rgb(83, 168, 133) transparent transparent;
}
.showVal:hover {
}
.arrows {
  position: absolute;
  float: right;
  width: 28px;
  top: 38%;
  right: 0;
  height: 162px;
  background-color: rgba(245, 249, 250, 0.98);
  z-index: 3;
  border-radius: 5px 0 0 5px;
  transition: all 0.3s;
}
.arrowsTop {
  position: absolute;
  float: right;
  width: 162px;
  top: 0;
  right: 40%;
  height: 28px;
  background-color: #f5f9fa;
  z-index: 3;
  border-radius: 0 0 5px 5px;
  transition: all 0.3s;
}
.arrows .MapArrorSvg {
  position: absolute;
  float: right;
  right: 0;
  width: 100%;
  height: 12%;
  top: 45%;
  transition: all 0.5s;
}
/* .MapArrorSvg {
  color: red;
  width: 15px;
  height: 15px;
} */
.arrowsTop .MapArrorSvg {
  position: absolute;
  float: right;
  right: 0;
  width: 100%;
  height: 50%;
  top: 30%;
  transition: all 0.5s;
}
.machineShow {
  position: absolute;
  float: right;
  width: 500px;
  top: 50px;
  right: 44px;
  height: 90%;
  /* background-color: red; */
  z-index: 2;
  transition: all 0.5s;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/* 显示区域的动画 */
.machineShow::-webkit-scrollbar {
  display: none; /*隐藏滚动条*/
}
.machineListFade-enter-active {
  opacity: 1;
}
.machineListFade-enter {
  transform: translateX(100%);
}
.machineListFade-enter-to {
  transform: translateX(0);
}
.machineListFade-leave-active {
  opacity: 0;
}
.machineListFade-leave {
  transform: translateX(0);
}
.machineListFade-leave-to {
  transform: translateX(100%);
}
.machineListFade2-enter-active {
  opacity: 1;
}
.machineListFade2-enter {
  transform: translateY(-100%);
}
.machineListFade2-enter-to {
  transform: translateY(0);
}
.machineListFade2-leave-active {
  opacity: 0;
}
.machineListFade2-leave {
  transform: translateY(0);
}
.machineListFade2-leave-to {
  transform: translateY(-100%);
}
/* 地區样式 */
.position {
  position: relative;
  float: right;
  width: 100%;
  height: 50px;
  border-radius: 15px;
  background-color: rgba(245, 249, 250, 0.83);
  flex-shrink: 0;
}
/deep/.position .el-radio-button__inner {
  border: none;
  height: 100%;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 20px;
  color: rgb(12, 12, 12);
  text-align: center;
  line-height: 28px;
}
/deep/ .el-radio-button__inner,
.el-radio-group {
  width: 100%;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border: none;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
}
/* 机器状态示例 */

.status ul {
  padding: 0;
  margin: 0;
}
.status {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 140px;
  border-radius: 15px;
  padding: 0;
  font-size: 0;
  background-color: rgba(245, 249, 250, 0.83);
  flex-wrap: wrap;
  /* gap: 30px; */
  gap: 5px;
  justify-content: space-evenly;
  flex-shrink: 0;
}
.status div {
  flex: 1;
  height: 100%;
  font-size: 15px;
  box-sizing: border-box;
  text-align: center;
  vertical-align: top;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  /* align-items: baseline; */
  /* margin-right: 20px; */
}
.status div img {
  /* margin-top: 20px; */
  /* margin: 10px 0 0 0; */
  vertical-align: middle;
  height: 88px;
  width: 67px;
}
.status p {
  width: 100%;
  height: 10%;
  text-align: top;
  margin-top: 5px;
  font-size: 15px;
  color: #757578;
  /* margin-top: -10px;
  margin-bottom: 10px; */
}
/* 搜索栏 */
.search {
  /* position: relative; */
  float: right;
  width: 100%;
  height: 100px;
  /* top: 150px; */
  border-radius: 15px;
  background-color: rgba(245, 249, 250, 0.83);
  flex-shrink: 0;
}
/deep/.inputSearch .el-input__inner {
  margin: 14px 14px 8px 14px;
  width: 95%;
}
/deep/ .inputoptions .el-input__inner {
  width: 100%;
}
/deep/.el-input__inner {
  border-radius: 15px;
  background-color: #ededed;
}
/* 地点 */
.address {
  /* position: absolute; */
  float: right;
  width: 100%;
  height: 35px;
  top: 260px;
  border-radius: 15px;
  background-color: rgba(245, 249, 250, 0.83);
  flex-shrink: 0;
  display: flex;
  cursor: pointer;
}
.pre {
  font-size: 10px;
  text-align: center;
  line-height: 35px;
}
.pre:first-child {
  border-radius: 15px 0 0 15px;
}
.pre:last-child {
  border-radius: 0 15px 15px 0;
}

.last {
  border-radius: 15px !important;
}

/* 数据列表 */
.list {
  width: 100%;
  background-color: rgb(146, 206, 178, 0.53);
  height: 100%;
  border-radius: 15px;
}
.el-tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.searchBtn {
  border-radius: 20px;
  margin-left: 8px;
  border: none;
}
.resetBtn {
  border-radius: 20px;
  border: none;
}
/deep/.el-tabs--card > .el-tabs__header {
  border: none;
}
/deep/.el-tabs__nav-scroll {
  /* background-color: rgb(146, 206, 178, 0.53); */
  border-left: none;
  border-radius: 15px 15px 0 0;
  height: 30px;
  text-align: center;
  vertical-align: middle;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  height: 30px;
  border-left: none;
  border: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__item:not(:first-child) {
  height: 30px;
  border-left: none;
  border: none;
  text-align: center;
  vertical-align: middle;
  flex: 1;
  /* width: 125px; */
}
/deep/.el-tabs__item {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: white;
  border-left: none;
}
/deep/.el-tabs__item.is-active {
  color: #87c58c;
  background-color: rgba(245, 249, 250, 0.83);
  border-radius: 10px 10px 0 0;
  position: relative;
}
/deep/.el-tabs__item.is-active::before {
  width: 10px;
  height: 10px;
  position: absolute;
  left: -10px;
  bottom: -1px;
  border: none;
  background: url("../../../assets/mapImg/圆角.png");
  background-size: 10px 10px;
  padding: 0;
  transform: rotate(-90deg);
  content: "";
}
/deep/.el-tabs__item.is-active::after {
  width: 10px;
  height: 10px;
  position: absolute;
  right: -10px;
  bottom: -1px;
  border: none;
  background: url("../../../assets/mapImg/圆角.png");
  background-size: 10px 10px;
  padding: 0;
  content: "";
}

/deep/.el-col {
  margin-bottom: 10px;
  box-sizing: border-box;
}
/deep/.el-tabs__item:hover {
  color: #1f5d24;
}
/deep/.el-tabs__content {
  flex-grow: 1;
  overflow: hidden;
}
/deep/.el-tabs__header {
  margin: 0;
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none;
}
</style>
